// utils/breadcrumbMap.js
const breadcrumbMap = {
  "/login": [{ label: "Login", key: "label.login", ns: "breadcrumb" }],
  "/ota": [{ label: "Otp", key: "label.otp", ns: "breadcrumb" }],
  "/tprm_dashboard": [
    { label: "Dashboard and Reports", key: "menu.dashboard", ns: "sidebar" },
    { label: "TPRM Dashboard", key: "menu.dashboard.tprm", ns: "sidebar" }
  ],
  "/command_center": [
    { label: "Dashboard and Reports", key: "menu.dashboard", ns: "sidebar" },
    { label: "Command Center", key: "menu.commandCenter", ns: "sidebar" }
  ],
  "/crq_dashboard": [
    { label: "Dashboard and Reports", key: "menu.dashboard", ns: "sidebar" },
    { label: "CRQ Dashboard", key: "menu.dashboard.crq", ns: "sidebar" }
  ],
  "/crp_dashboard": [
    { label: "Dashboard and Reports", key: "menu.dashboard", ns: "sidebar" },
    { label: "Resilience Posture Dashboard", key: "menu.dashboard.crp", ns: "sidebar" }
  ],

  // ---------------- Compliance Operations ----------------
  "/framework_and_standards": [
    { label: "Compliance Operations", key: "menu.compliance", ns: "sidebar", to: "/framework_and_standards" },
    { label: "Frameworks and Standards", key: "menu.compliance.frameworks", ns: "sidebar" }
  ],
  "/assets_mgnt": [
    { label: "Compliance Operations", key: "menu.compliance", ns: "sidebar", to: "/framework_and_standards" },
    { label: "Assets Management", key: "label.assetsManagement", ns: "breadcrumb" }
  ],
  "/asset_management": [
    { label: "Compliance Operations", key: "menu.compliance", ns: "sidebar", to: "/framework_and_standards" },
    { label: "Assets", key: "menu.assets.assets", ns: "sidebar" }
  ],
  "/process_management": [
    { label: "Compliance Operations", key: "menu.compliance", ns: "sidebar", to: "/framework_and_standards" },
    { label: "Process Management", key: "menu.compliance.process", ns: "sidebar" }
  ],
  "/asset_mapping": [
    { label: "Compliance Operations", key: "menu.compliance", ns: "sidebar", to: "/framework_and_standards" },
    { label: "Asset Mapping", key: "menu.compliance.mapping", ns: "sidebar" }
  ],
  "/progress_tracker": [
    { label: "Compliance Operations", key: "menu.compliance", ns: "sidebar", to: "/framework_and_standards" },
    { label: "Progress Tracker", key: "menu.compliance.progress", ns: "sidebar" }
  ],
  "/evidence_tracker": [
    { label: "Compliance Operations", key: "menu.compliance", ns: "sidebar", to: "/framework_and_standards" },
    { label: "Evidence Tracker", key: "menu.compliance.evidence", ns: "sidebar" }
  ],
  "/quantify_data_nist": [
    { label: "Compliance Operations", key: "menu.compliance", ns: "sidebar", to: "/framework_and_standards" },
    { label: "Frameworks and Standards", key: "menu.compliance.frameworks", ns: "sidebar", to: "/framework_and_standards" },
    { label: "NIST CSF Standards 2.0", key: "label.nistCsf20", ns: "breadcrumb" }
  ],
  "/quantify_data_cara": [
    { label: "Compliance Operations", key: "menu.compliance", ns: "sidebar", to: "/framework_and_standards" },
    { label: "Frameworks and Standards", key: "menu.compliance.frameworks", ns: "sidebar", to: "/framework_and_standards" },
    { label: "NIST CSF Standards 1.1", key: "label.nistCsf11", ns: "breadcrumb" }
  ],
  "/quantify_data_ransomware": [
    { label: "Compliance Operations", key: "menu.compliance", ns: "sidebar", to: "/framework_and_standards" },
    { label: "Frameworks and Standards", key: "menu.compliance.frameworks", ns: "sidebar", to: "/framework_and_standards" },
    { label: "NIST Ransomware Standards", key: "label.nistRansomware", ns: "breadcrumb" }
  ],
  "/nist_ai_framework": [
    { label: "Compliance Operations", key: "menu.compliance", ns: "sidebar", to: "/framework_and_standards" },
    { label: "Frameworks and Standards", key: "menu.compliance.frameworks", ns: "sidebar", to: "/framework_and_standards" },
    { label: "NIST AI RMF", key: "label.nistAiRmf", ns: "command_center" }
  ],
  "/iso27001_framework": [
    { label: "Compliance Operations", key: "menu.compliance", ns: "sidebar", to: "/framework_and_standards" },
    { label: "Frameworks and Standards", key: "menu.compliance.frameworks", ns: "sidebar", to: "/framework_and_standards" },
    { label: "ISO IEC 27001:27002 Standards", key: "label.isoIec27001", ns: "breadcrumb" }
  ],
  "/cisv8_framework": [
    { label: "Compliance Operations", key: "menu.compliance", ns: "sidebar", to: "/framework_and_standards" },
    { label: "Frameworks and Standards", key: "menu.compliance.frameworks", ns: "sidebar", to: "/framework_and_standards" },
    { label: "CIS V8.1 Standards", key: "label.cisV81", ns: "breadcrumb" }
  ],
  "/rbi_csf_framework": [
    { label: "Compliance Operations", key: "menu.compliance", ns: "sidebar", to: "/framework_and_standards" },
    { label: "Frameworks and Standards", key: "menu.compliance.frameworks", ns: "sidebar", to: "/framework_and_standards" },
    { label: "RBI CSF Standards", key: "label.rbiCsf", ns: "breadcrumb" }
  ],
  "/nist_ai_compliance_tracker": [
    { label: "Compliance Tracker Framework", key: "label.complianceTrackerFramework", ns: "breadcrumb" }
  ],
  "/compliance_tracker_framework": [
    { label: "Compliance Operations", key: "menu.compliance", ns: "sidebar", to: "/framework_and_standards" },
    { label: "Compliance Tracker Framework", key: "label.complianceTrackerFramework", ns: "breadcrumb" }
  ],

  // ---------------- Risk Management ----------------
  "/cara_roi_quantifier": [
    { label: "Risk Management", key: "menu.riskManagement", ns: "sidebar" }, // section landing
    { label: "CARA ROI Quantifier", key: "menu.risk.roi", ns: "sidebar" }
  ],
  "/risk_register": [
    { label: "Risk Management", key: "menu.riskManagement", ns: "sidebar" },
    { label: "Enterprise Risk Register", key: "menu.riskManagement.enterpriseRegister", ns: "sidebar" }
  ],
  "/add_risk_scenario": [
    { label: "Risk Management", key: "menu.riskManagement", ns: "sidebar" },
    { label: "Enterprise Risk Register", key: "menu.riskManagement.enterpriseRegister", ns: "sidebar", to: "/risk_register" },
    { label: "Add Risk Scenario", key: "label.addRiskScenario", ns: "breadcrumb" }
  ],
  "/risk_register_tracker": [
    { label: "Risk Management", key: "menu.riskManagement", ns: "sidebar" },
    { label: "Risk Register Tracker", key: "menu.riskManagement.tracker", ns: "sidebar" }
  ],
  "/risk_assessment": [
    { label: "Risk Management", key: "menu.riskManagement", ns: "sidebar" },
    { label: "Risk Assessments", key: "menu.riskManagement.assessments", ns: "sidebar" }
  ],
  "/isms_risk_assessment": [
    { label: "Risk Management", key: "menu.riskManagement", ns: "sidebar" },
    { label: "Risk Assessments", key: "menu.riskManagement.assessments", ns: "sidebar", to: "/risk_assessment" },
    { label: "ISMS Risk Assessment", key: "label.ismsRiskAssessment", ns: "breadcrumb" }
  ],
  "/cis_risk_assessment": [
    { label: "Risk Management", key: "menu.riskManagement", ns: "sidebar" },
    { label: "Risk Assessments", key: "menu.riskManagement.assessments", ns: "sidebar", to: "/risk_assessment" },
    { label: "CIS Risk Assessment", key: "label.cisRiskAssessment", ns: "breadcrumb" }
  ],
  "/risk_assesment_tracker": [
    { label: "Risk Management", key: "menu.riskManagement", ns: "sidebar" },
    { label: "Risk Assessments Tracker", key: "menu.risk.assessmentTracker", ns: "sidebar" }
  ],
  "/vrm_risk_register_requests": [
    { label: "Dashboard and Reports", key: "menu.dashboard", ns: "sidebar", to: "/vrm_client_dashboard" },
    { label: "Risk Register Requests", key: "label.riskRegisterRequests", ns: "breadcrumb" }
  ],
  "/vrm_audit_checklist_requests": [
    { label: "Dashboard and Reports", key: "menu.dashboard", ns: "sidebar", to: "/vrm_client_dashboard" },
    { label: "Audit Checklist Requests", key: "label.auditChecklistRequests", ns: "breadcrumb" }
  ],
  "/vrm_audit_buddy_requests": [
    { label: "Dashboard and Reports", key: "menu.dashboard", ns: "sidebar", to: "/vrm_client_dashboard" },
    { label: "Audit Buddy Requests", key: "label.auditBuddyRequests", ns: "breadcrumb" }
  ],
  "/vrm_custom_questionnaires": [
    { label: "Dashboard and Reports", key: "menu.dashboard", ns: "sidebar", to: "/vrm_client_dashboard" },
    { label: "Custom Questionnaire Requests", key: "vrm.title", ns: "tprm_custom_questionnaire" }
  ],
  "/vrm_framework_requests": [
    { label: "Dashboard and Reports", key: "menu.dashboard", ns: "sidebar", to: "/vrm_client_dashboard" },
    { label: "Framework Requests", key: "menu.vrm.frameworkRequests", ns: "sidebar" }
  ],
  "/vrm_audit_trails": [
    { label: "My Settings", to: "/vrm_dashboard" },
    { label: "Audit Trails" }
  ],
  "/vrm_recommendations": [
    { label: "Dashboard and Reports", to: "/vrm_dashboard" },
    { label: "Recommendations Register" }
  ],
  "/admin_vrm_recommendations": [
    { label: "Virtual Risk Manager", to: "/contact_vrm" },
    { label: "VRM Recommendations" }
  ],
  "/vrm_tracker": [
    { label: "Virtual Risk Manager", to: "/contact_vrm" },
    { label: "VRM Tracker" }
  ],
  "/vrm_audit_trails": [
    { label: "My Settings", to: "/vrm_dashboard" },
    { label: "Audit Trails" }
  ],
  "/vrm_recommendations": [
    { label: "Dashboard and Reports", to: "/vrm_dashboard" },
    { label: "Recommendations Register" }
  ],
  "/admin_vrm_recommendations": [
    { label: "Virtual Risk Manager", to: "/contact_vrm" },
    { label: "VRM Recommendations" }
  ],
  "/vrm_tracker": [
    { label: "Virtual Risk Manager", to: "/contact_vrm" },
    { label: "VRM Tracker" }
  ],
  "/vrm_audit_trails": [
    { label: "My Settings", to: "/vrm_dashboard" },
    { label: "Audit Trails" }
  ],
  "/vrm_recommendations": [
    { label: "Dashboard and Reports", to: "/vrm_dashboard" },
    { label: "Recommendations Register" }
  ],
  "/admin_vrm_recommendations": [
    { label: "Virtual Risk Manager", to: "/contact_vrm" },
    { label: "VRM Recommendations" }
  ],
  "/vrm_tracker": [
    { label: "Virtual Risk Manager", to: "/contact_vrm" },
    { label: "VRM Tracker" }
  ],
  "/regulatory_library/penalties": [
    { label: "Regulatory Library", key: "menu.regulatoryLibrary", ns: "sidebar" },
    { label: "Penalties", key: "menu.regulatoryLibrary.penalties", ns: "sidebar" }
  ],

  // ---------------- Audit Management ----------------
  "/manage_audit": [
    { label: "Audit Management", key: "menu.audit", ns: "sidebar" },
    { label: "Manage Audits", key: "menu.audit.manage", ns: "sidebar" }
  ],
  "/create_audit": [
    { label: "Audit Management", key: "menu.audit", ns: "sidebar", to: "/manage_audit" },
    { label: "Create Audit", key: "label.createAudit", ns: "breadcrumb" }
  ],

  "/audit_documents": [
    { label: "Audit Management", key: "menu.audit", ns: "sidebar" },
    { label: "Audit Documents", key: "menu.audit.documents", ns: "sidebar" }
  ],
  "/audit_tracker": [
    { label: "Audit Management", key: "menu.audit", ns: "sidebar" },
    { label: "Audit Tracker", key: "menu.audit.tracker", ns: "sidebar" }
  ],
  "/audit_checklist": [
    { label: "Audit Management", key: "menu.audit", ns: "sidebar" },
    { label: "Audit Checklist", key: "menu.audit.checklist", ns: "sidebar" }
  ],
  "/audit-buddy": [
    { label: "Audit Management", key: "menu.audit", ns: "sidebar" },
    { label: "Audit Checklist", key: "menu.audit.checklist", ns: "sidebar", to: "/audit_checklist" },
    { label: "Audit Buddy", key: "menu.audit.buddy", ns: "sidebar" }
  ],
  "/audit-buddy/generate": [
    { label: "Audit Management", key: "menu.audit", ns: "sidebar" },
    { label: "Audit Checklist", key: "menu.audit.checklist", ns: "sidebar", to: "/audit_checklist" },
    { label: "Audit Buddy", key: "menu.audit.buddy", ns: "sidebar", to: "/audit-buddy" },
    { label: "Question Generator", key: "label.questionGenerator", ns: "breadcrumb" }
  ],
  "/ai_weapons_checklist": [
    { label: "Audit Management", key: "menu.audit", ns: "sidebar" },
    { label: "Audit Checklist", key: "menu.audit.checklist", ns: "sidebar", to: "/audit_checklist" },
    { label: "AI Weapons Checklist", key: "label.aiWeaponsChecklist", ns: "breadcrumb" }
  ],
  "/business_continuity_checklist": [
    { label: "Audit Management", key: "menu.audit", ns: "sidebar" },
    { label: "Audit Checklist", key: "menu.audit.checklist", ns: "sidebar", to: "/audit_checklist" },
    { label: "Business Continuity Checklist", key: "label.businessContinuityChecklist", ns: "breadcrumb" }
  ],
  "/soc2_checklist": [
    { label: "Audit Management", key: "menu.audit", ns: "sidebar" },
    { label: "Audit Checklist", key: "menu.audit.checklist", ns: "sidebar", to: "/audit_checklist" },
    { label: "SOC 2 Checklist", key: "label.soc2Checklist", ns: "breadcrumb" }
  ],
  "/iso_27001_checklist": [
    { label: "Audit Management", key: "menu.audit", ns: "sidebar" },
    { label: "Audit Checklist", key: "menu.audit.checklist", ns: "sidebar", to: "/audit_checklist" },
    { label: "ISO 27001 Checklist", key: "label.iso27001Checklist", ns: "breadcrumb" }
  ],
  "/boatswana_data_protection": [
    { label: "Audit Management", key: "menu.audit", ns: "sidebar" },
    { label: "Audit Checklist", key: "menu.audit.checklist", ns: "sidebar", to: "/audit_checklist" },
    { label: "Botswana Checklist", key: "label.botswanaChecklist", ns: "breadcrumb" }
  ],
  "/gdpr_audit_checklist": [
    { label: "Audit Management", key: "menu.audit", ns: "sidebar" },
    { label: "Audit Checklist", key: "menu.audit.checklist", ns: "sidebar", to: "/audit_checklist" },
    { label: "GDPR Checklist", key: "label.gdprChecklist", ns: "breadcrumb" }
  ],
  "/insider_threat_checklist": [
    { label: "Audit Management", key: "menu.audit", ns: "sidebar" },
    { label: "Audit Checklist", key: "menu.audit.checklist", ns: "sidebar", to: "/audit_checklist" },
    { label: "Insider Threat Checklist", key: "label.insiderThreatChecklist", ns: "breadcrumb" }
  ],
  "/fatf_checklist": [
    { label: "Audit Management", key: "menu.audit", ns: "sidebar" },
    { label: "Audit Checklist", key: "menu.audit.checklist", ns: "sidebar", to: "/audit_checklist" },
    { label: "FATF Checklist", key: "label.fatfChecklist", ns: "breadcrumb" }
  ],
  // ---------------- Third Party Risk Management ----------------
  "/questionnaire": [
    { label: "Third Party Risk Management", key: "menu.tprm", ns: "sidebar", to: "/questionnaire" },
    { label: "Questionnaire", key: "menu.tprm.questionnaire", ns: "sidebar" }
  ],
  "/view_questionnaire": [
    { label: "Questionnaire", key: "menu.tprm.questionnaire", ns: "sidebar", to: "/questionnaire" },
    { label: "View Questionnaire", key: "questionnaire.btn.view", ns: "tprm" }
  ],
  // Bug 426: "Third Party Risk Management" is a sidebar group (no page of its
  // own), so in the Third Party Users chain it is plain text instead of a
  // link to the unrelated Questionnaire page.
  "/third_party_users": [
    { label: "Third Party Risk Management", key: "menu.tprm", ns: "sidebar" },
    { label: "Third Party Users", key: "menu.tprm.users", ns: "sidebar" }
  ],
  "/entity_dashboard": [
    { label: "Third Party Risk Management", key: "menu.tprm", ns: "sidebar", to: "/questionnaire" },
    { label: "Entity Dashboard", key: "label.entityDashboard", ns: "breadcrumb" }
  ],
  "/create_tprm_admin": [
    { label: "Third Party Risk Management", key: "menu.tprm", ns: "sidebar" },
    { label: "Third Party Users", key: "menu.tprm.users", ns: "sidebar", to: "/third_party_users" },
    { label: "Create Third Party User", key: "tprm.title.createUser", ns: "tprm" }
  ],
  "/assign_tprm_questionnaire": [
    { label: "Third Party Risk Management", key: "menu.tprm", ns: "sidebar" },
    { label: "Third Party Users", key: "menu.tprm.users", ns: "sidebar", to: "/third_party_users" },
    { label: "Send TPRM Questionnaire", key: "title.wizard", ns: "tprm_questionnaire_wizard" }
  ],
  "/Edit_Third_Party_User": [
    { label: "Third Party Risk Management", key: "menu.tprm", ns: "sidebar" },
    { label: "Third Party Users", key: "menu.tprm.users", ns: "sidebar", to: "/third_party_users" },
    { label: "Edit Third Party User", key: "tprm.title.editUser", ns: "tprm" }
  ],
  "/audit_trail_users": [
    { label: "Third Party Risk Management", key: "menu.tprm", ns: "sidebar", to: "/questionnaire" },
    { label: "Audit Trail", key: "menu.audit.trail", ns: "sidebar" }
  ],
  "/tprm_tracker": [
    { label: "Third Party Risk Management", key: "menu.tprm", ns: "sidebar", to: "/questionnaire" },
    { label: "TPRM Tracker", key: "menu.tprm.tracker", ns: "sidebar" }
  ],
  // ---------------- User Management ----------------
  "/role_management": [
    { label: "User Management", key: "menu.userManagement", ns: "sidebar", to: "/my_users" },
    { label: "Role Management", key: "menu.userManagement.roles", ns: "sidebar" }
  ],
  "/department_management": [
    { label: "User Management", key: "menu.userManagement", ns: "sidebar", to: "/my_users" },
    { label: "Department Management", key: "menu.userManagement.departments", ns: "sidebar" }
  ],
  "/my_users": [
    { label: "User Management", key: "menu.userManagement", ns: "sidebar", to: "/my_users" },
    { label: "My Users", key: "menu.userManagement.users", ns: "sidebar" }
  ],
  "/create_cara_self_user": [
    { label: "User Management", key: "menu.userManagement", ns: "sidebar", to: "/my_users" },
    { label: "My Users", key: "menu.userManagement.users", ns: "sidebar", to: "/my_users" },
    { label: "Create User", key: "user.title.createUser", ns: "user_mgmt" }
  ],
  "/edit_user": [
    { label: "User Management", key: "menu.userManagement", ns: "sidebar", to: "/my_users" },
    { label: "My Users", key: "menu.userManagement.users", ns: "sidebar", to: "/my_users" },
    { label: "Edit User", key: "user.title.editUser", ns: "user_mgmt" }
  ],
  "/audit_trail_user": [
    { label: "User Management", key: "menu.userManagement", ns: "sidebar", to: "/my_users" },
    { label: "Audit Trail", key: "menu.audit.trail", ns: "sidebar" }
  ],

  // ---------------- VRM ----------------
  "/contact_vrm": [
    { label: "Virtual Risk Manager", key: "menu.vrm", ns: "sidebar", to: "/contact_vrm" },
    { label: "Contact VRM", key: "menu.vrm.contact", ns: "sidebar" }
  ],
  "/my_request": [
    { label: "Virtual Risk Manager", key: "menu.vrm", ns: "sidebar", to: "/contact_vrm" },
    { label: "My Request", key: "menu.vrm.request", ns: "sidebar" }
  ],
  "/connect_with_vrm": [
    { label: "Virtual Risk Manager", key: "menu.vrm", ns: "sidebar", to: "/contact_vrm" },
    { label: "Connect with VRM", key: "title.connectWithVrm", ns: "vrm" }
  ],

  // ---------------- CRP & Others ----------------
  "/cyber_resilience_posture": [{ label: "Cyber Resilience Posture", key: "menu.cyberResilience", ns: "sidebar" }],

  "/ask_the_expert": [{ label: "Ask the Expert", key: "menu.support.expert", ns: "sidebar" }],
  "/announcement": [{ label: "Announcements", key: "label.announcements", ns: "breadcrumb" }],

  "/submit_feedback": [
    { label: "Feedback and Suggestions", key: "label.feedbackAndSuggestions", ns: "breadcrumb", to: "/submit_feedback" },
    { label: "Submit Feedback", key: "menu.feedback.submit", ns: "sidebar" }
  ],
  "/my_feedback": [
    { label: "Feedback and Suggestions", key: "label.feedbackAndSuggestions", ns: "breadcrumb", to: "/submit_feedback" },
    { label: "My Feedback", key: "menu.feedback.my", ns: "sidebar" }
  ],
  "/email_support": [
    { label: "Email Support", key: "menu.support.email", ns: "sidebar", to: "/email_support" },
    { label: "Email Support", key: "menu.support.email", ns: "sidebar" }
  ],

  "/audit_trails": [
    { label: "My Settings", key: "breadcrumb.mySettings", ns: "common", to: "/profile" },
    { label: "Audit Trails", key: "title.main", ns: "audit_trails" }
  ],
  "/privacy": [
    { label: "My Settings", key: "breadcrumb.mySettings", ns: "common", to: "/profile" },
    { label: "Privacy", key: "menu.settings.privacy", ns: "sidebar" }
  ],
  "/profile": [
    { label: "My Settings", key: "breadcrumb.mySettings", ns: "common", to: "/profile" },
    { label: "Profile", key: "menu.settings.profile", ns: "sidebar" }
  ],

  "/superadmin_vrm_mapping": [
    { label: "Superadmin", key: "label.superadmin", ns: "breadcrumb", to: "/superadmin_dashboard" },
    { label: "VRM Mapping", key: "label.vrmMapping", ns: "breadcrumb" }
  ],
  "/superadmin_storage": [
    { label: "Superadmin", key: "label.superadmin", ns: "breadcrumb", to: "/superadmin_dashboard" },
    { label: "Storage Management", key: "label.storageManagement", ns: "breadcrumb" }
  ],
  "/superadmin_ai_usage": [
    { label: "Superadmin", key: "label.superadmin", ns: "breadcrumb", to: "/superadmin_dashboard" },
    { label: "AI Usage & Limits", key: "label.aiUsageLimits", ns: "breadcrumb" }
  ],

  "/tprm_questionnaire": [
    { label: "TPRM Questionnaire", key: "menu.tprmQuestionnaireHeading", ns: "sidebar", to: "/tprm_questionnaire" }

  ],
  "/tprm_v2_questionnaire": [
    { label: "My TPRM Questionnaires", key: "title.gallery", ns: "tprm_v2_questionnaire", to: "/tprm_v2_questionnaire" }
  ],
  "/vrm_client_dashboard": [
    { label: "VRM", key: "label.vrmAlt", ns: "command_center", to: "/vrm_dashboard" },
    { label: "Client Dashboard", key: "label.clientDashboard", ns: "breadcrumb" }
  ],
  "/view_tprm_questionnaire": [
    { label: "TPRM Questionnaire", key: "menu.tprmQuestionnaireHeading", ns: "sidebar", to: "/tprm_questionnaire" },
    { label: "View TPRM Questionnaire", key: "label.viewTprmQuestionnaire", ns: "breadcrumb" }
  ],

  "/cara_tprm_user_details": [
    { label: "User Management", key: "menu.userManagement", ns: "sidebar", to: "/my_users" },
    { label: "My Users", key: "menu.userManagement.users", ns: "sidebar", to: "/my_users" },
    { label: "CARA TPRM User Details", key: "label.caraTprmUserDetails", ns: "breadcrumb" }
  ],

  "/ai-questionnaire-generator": [
    { label: "Third Party Risk Management", key: "menu.tprm", ns: "sidebar", to: "/questionnaire" },
    { label: "AI Questionnaire Generator", key: "questionnaire.card.aiTitle", ns: "tprm" }
  ],

  // ---------------- Documentation & Vault ----------------
  "/documentation": [
    { label: "Documentation", key: "menu.documentation", ns: "sidebar", to: "/documentation" },
    { label: "AI Document Generator", key: "label.aiDocumentGenerator", ns: "breadcrumb" }
  ],
  "/document_vault": [
    { label: "Documentation", key: "menu.documentation", ns: "sidebar", to: "/documentation" },
    { label: "Document Vault", key: "menu.documentation.vault", ns: "sidebar" }
  ],
  "/policy_library": [
    { label: "Documentation", key: "menu.documentation", ns: "sidebar", to: "/documentation" },
    { label: "Policy Library", key: "menu.documentation.policy", ns: "sidebar" }
  ],
  "/policy_library_admin": [
    { label: "Superadmin", key: "label.superadmin", ns: "breadcrumb", to: "/superadmin_dashboard" },
    { label: "Policy Library Management", key: "label.policyLibraryManagement", ns: "breadcrumb" }
  ],

};

// Parent-segment chains for routes with a dynamic id in the path (e.g. /tprm_assessment/:assessmentId).
// The final (id) segment is appended by Breadcrumbs.js and is never a link, since no bare listing
// route exists at the base path itself.
export const dynamicBreadcrumbMap = {
  "/tprm_assessment": [
    { label: "Third Party Risk Management", key: "menu.tprm", ns: "sidebar" },
    { label: "Third Party Users", key: "menu.tprm.users", ns: "sidebar", to: "/third_party_users" }
  ]
};

export default breadcrumbMap;
